import ShadowContainerHorizontal from '@atoms/ShadowContainerHorizontal/ShadowContainerHorizontal';
import { ILink } from '@models/ILink';

interface Props {
  readonly links: ILink[];
}

const SectionNavigation = ({ links = [] }: Props) => (
  <section className="border-grey-500 border-b border-solid bg-grey-600 text-white">
    {!!links.length && (
      <div className="md:px-5 lg:px-7">
        <ShadowContainerHorizontal
          shadowColour="from-grey-600"
          hasTabbableNestedItems
        >
          <div className="scrollbar-hide flex gap-4 whitespace-nowrap px-5 py-4 sm:pr-10 md:gap-7 md:px-[3px] md:py-7">
            {links.length > 0 &&
              links.map(
                (link) =>
                  link.name && (
                    <a
                      key={`section-nav-link-${link.name}}`}
                      href={link.url}
                      draggable={false}
                      className="body-three select-none hover:cursor-pointer hover:text-yellow active:text-yellow"
                      target={link.target}
                    >
                      {link.name}
                    </a>
                  )
              )}
          </div>
        </ShadowContainerHorizontal>
      </div>
    )}
  </section>
);

export default SectionNavigation;
